const form = $('.js-businessFormAjax');
const action = form.attr('action');
const success = $('.js-businessFormSuccess');

form.on('submit', (e) => submitForm(e));

$('.js-businessFormClose').on('click', (e) => {
	resetForm();
});

function submitForm(e){
	const data = new FormData(form[0]);

	e.preventDefault();

	if (!$(e.currentTarget).valid()) return

	$.ajax({
		url: action,
		data: data,
		processData: false,
		contentType: false,
		method: 'POST',
		success: function(data) {
			if (data.status === 'success') {
				success.show();
				form.hide();
				$('html, body').animate({
					scrollTop: success.offset().top - 80
				});
			}
		}
	})
}

function resetForm() {
	success.hide();
	form.show();
	form[0].reset();
	$('.js-fileDelete').trigger('click');
}
